import React, { FC, useEffect, useState } from "react";
import styles from "styles.module.css";
import {
	Grid,
	GridColumn,
	GridColumnProps,
	GridCustomCellProps,
	GridCustomRowProps,
	GridEditChangeEvent,
	GridPageChangeEvent,
	GridProps,
	GridRowProps,
} from "@progress/kendo-react-grid";
import { Skeleton } from "@progress/kendo-react-indicators";
import { COLOR } from "utils/constant";
import { SortDescriptor } from "@progress/kendo-data-query";
import { GridHeaderCellProps } from "@progress/kendo-react-grid";
import { isColumnFiltered } from "utils/statUtils";
import { formatNorwegianNumber } from "utils/helper";
import { t } from "i18next";
interface CustomGridProps extends Omit<
	GridProps,
	"onExpandChange" | "inEdit" | "editField"
> {
	skip?: number;
	take?: number;
	sort?: SortDescriptor[];
	sortable?: boolean;
	pageable?: boolean;
	pageSizes?: number[];

	data?: any[];
	onPageChange?: (event: GridPageChangeEvent) => void;
	showRowBgColor?: {
		bgColor: string;
		falseBgColor: string;
		checkValue: any;
		checkField: string;
		showAlways?: boolean;
	};
	gridColumns?: GridColumnProps[];
	handelShowRowBgColor?: (rowData: GridRowProps) => string;
}

const CustomGrid: React.FC<CustomGridProps> = ({
	skip = 0,
	// take = 10,
	pageSize = 10,

	gridColumns = [],
	onDetailExpandChange,
	data = [],
	// editField = "inEdit",
	showRowBgColor,
	handelShowRowBgColor,
	className,
	...props
}) => {
	//const [sortItem, setSortItem] = useState<SortDescriptor[]>(sort);

	return (
		<div style={{ overflowX: "auto", width: "fit-content" }}>
			<Grid
				rows={{
					data: (row) => CustomRowRender(row, handelShowRowBgColor),
				}}
				data={data.slice(skip, props.take || data.length)}
				// data ={data}
				//take={take}
				skip={skip}
				// cells={{
				// 	data: ( props) => loadingCell( props),
				// }}
				onDetailExpandChange={onDetailExpandChange}
				className={className}
				{...props}
				// edit={edit}
				// editable={props.editable}
				// editable={{ mode: "incell" }}
				// onEditChange={handleEditChange}
			>
				{gridColumns.map((GridItem, index) => (
					<GridColumn
						{...GridItem}
						key={index}
						// {...(GridItem as any)}
						// className={GridColumn.propTypes?.className + " no-border"}
					/>
				))}
			</Grid>
		</div>
	);
};

export default CustomGrid;

export const CustomRowRender = (
	//row: React.ReactElement<HTMLTableRowElement> as any,
	_row: any,
	handelShowRowBgColor?: (props: GridRowProps) => string,
	handleRowTextColor?: (props: GridRowProps) => string,
) => {
	const row = _row as GridCustomRowProps;
	// console.log("row", row);
	// console.log("props", props);
	let bgColor = "";
	const data = row.dataItem;
	const isExpanded = data?.detailExpand;
	let color = COLOR.TextLight;
	// color = COLOR.Grey20;

	if (!data?.status || data.status === 0) {
		color = COLOR.Grey20;
	}
	if (handelShowRowBgColor) {
		bgColor = handelShowRowBgColor(_row);
	}

	if (handleRowTextColor) {
		color = handleRowTextColor(_row);
	}

	if (isExpanded) {
		bgColor = COLOR.GridOpenedHeader;
	}

	return (
		<tr
			// children={row.children}
			{...row.trProps}
			className={`${styles.TableText}  ${styles.TextRobot} grid-row`}
			style={{
				backgroundColor: bgColor,
				color,
				height: "34px",
			}}
		>
			{row.children}
		</tr>
	);
};

export const CustomRowRenderNoTextChange = (
	//row: React.ReactElement<HTMLTableRowElement> as any,
	_row: any,
	handelShowRowBgColor?: (props: GridRowProps) => string,
	handleRowTextColor?: (props: GridRowProps) => string,
) => {
	const row = _row as GridCustomRowProps;

	let bgColor = "";
	const data = row.dataItem;
	const isExpanded = data?.detailExpand;
	let color = COLOR.TextLight;
	if (handleRowTextColor) {
		color = handleRowTextColor(_row);
	}

	if (handelShowRowBgColor) {
		bgColor = handelShowRowBgColor(_row);
	}

	if (isExpanded) {
		bgColor = COLOR.GridOpenedHeader;
	}

	return (
		<tr
			// children={row.children}
			{...row.trProps}
			className={`${styles.TableText}  ${styles.TextRobot} grid-row`}
			style={{
				backgroundColor: bgColor,
				color,
				height: "34px",
			}}
		>
			{row.children}
		</tr>
	);
};

export const FilterHeaderCellRender = (props: GridHeaderCellProps) => {
	const th: any = props;
	let isFiltered = false;
	if (props.columnMenuWrapperProps.filter) {
		isFiltered = isColumnFiltered(
			props.field as any,
			props.columnMenuWrapperProps.filter,
		);
	}
	return (
		<th
			className={th.thProps?.className}
			style={{
				backgroundColor: isFiltered ? "#ACD1E9" : "",
			}}
		>
			{props.children}
		</th>
	);
};
export const GroupHeaderCellGrossWeight = (cellProps: GridCustomCellProps) => {
	const newChildren = React.Children.map(cellProps.children, (child) => {
		const formatDecimal = 2;
		const sum = formatNorwegianNumber(
			cellProps.dataItem.aggregates.grossWeight.sum,
			formatDecimal,
			formatDecimal,
		);

		if (React.isValidElement(child) && child.props && child.props.children) {
			const updatedChild = React.cloneElement(
				child as React.ReactElement<any>,
				{
					children: React.Children.map(child.props.children, (nestedChild) => {
						if (typeof nestedChild === "string") {
							return `${nestedChild}  (${t("Total")} ${t("Weight")} : ${sum})`;
						}
						return nestedChild;
					}),
				},
			);
			return updatedChild;
		}
		return child;
	});

	const _tdProps: any = cellProps.tdProps;

	return (
		<td {...cellProps.tdProps} key={_tdProps?.key}>
			{newChildren}
		</td>
	);
};

// const loadingCell = (props: any) => {
// 	const field = props.field || "";
// 	console.log("props", tdElement);
// 	if (props.dataItem[field] === undefined) {
// 		// shows loading cell if no data
// 		return (
// 			<td>
// 				{" "}
// 				<Skeleton
// 					shape={"text"}
// 					style={{
// 						width: "100%",
// 					}}
// 				/>
// 			</td>
// 		);
// 	} // default rendering for this cell

// 	return tdElement;
// };

function rowRender(trElement: any, props: any) {
	const available = !props.dataItem.Discontinued;
	const green = {
		backgroundColor: "rgb(55, 180, 0,0.32)",
	};
	const red = {
		backgroundColor: "rgb(243, 23, 0, 0.32)",
	};
	const trProps = {
		style: available ? green : red,
		maxHeight: "38px",
	};
	return React.cloneElement(
		trElement,
		{
			...trProps,
		},
		trElement.props.children,
	);
}
